export default __webpack_public_path__ + "static/media/image-02.f98786a1.png";